// /lib/suggestions.js

// ---- date helpers ----
const fmt = (d) => d.toISOString().slice(0, 10); // YYYY-MM-DD

const startOfWeek = (d) => {
  const dt = new Date(d);
  const day = dt.getDay();                // 0=Sun ... 6=Sat
  const offset = (day === 0 ? -6 : 1 - day); // Monday start
  dt.setDate(dt.getDate() + offset);
  dt.setHours(0,0,0,0);
  return dt;
};
const endOfWeek = (d) => {
  const s = startOfWeek(d);
  const e = new Date(s); e.setDate(e.getDate() + 6); e.setHours(23,59,59,999);
  return e;
};
const firstOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
const lastOfMonth  = (d) => new Date(d.getFullYear(), d.getMonth() + 1, 0);
const firstOfPrevMonth = (d) => new Date(d.getFullYear(), d.getMonth() - 1, 1);
const lastOfPrevMonth  = (d) => new Date(d.getFullYear(), d.getMonth(), 0);

// build explicit ranges once
const today = new Date();
const todayISO = fmt(today);
const thisWeekFrom = fmt(startOfWeek(today));
const thisWeekTo   = fmt(endOfWeek(today));
const lastWeekEnd  = new Date(startOfWeek(today) - 1);
const lastWeekFrom = fmt(startOfWeek(lastWeekEnd));
const lastWeekTo   = fmt(endOfWeek(lastWeekEnd));
const thisMonthFrom = fmt(firstOfMonth(today));
const thisMonthTo   = fmt(lastOfMonth(today));
const prevMonthFrom = fmt(firstOfPrevMonth(today));
const prevMonthTo   = fmt(lastOfPrevMonth(today));
const thirtyAgoISO  = fmt(new Date(Date.now() - 30*24*60*60*1000));

// ===== CUSTOM (graph/table) =====
// label stays human-friendly; value is the backend payload object.
export const prompts = [
  {
    label: "Sales Forecast (3 months)",
    value: { msg: "custom_prompt_forecast", label: "Sales Forecast (3 months)", params: { months: 3 } }
  },
  {
    label: "Look for Supplier",
    value: { msg: "custom_prompt_find_supplier", label: "Look for Supplier", params: {} }
  }
];

// ===== NON-CUSTOM (plain chat) =====
export const nonCustomPrompts =  [
  { label: "Today's Sales Summary", value: `sales summary for ${new Date().toISOString().split('T')[0]}` },
  { label: "This Week's Sales", value: `sales summary from ${new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]} to ${new Date().toISOString().split('T')[0]}` },
  { label: "Low Stock Alerts", value: "list items with stock below reorder threshold" },
  { label: "Top Selling Items (Last 7 Days)", value: `top 5 selling items from ${new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]} to ${new Date().toISOString().split('T')[0]}` },
  { label: "Pending Orders", value: "list all pending orders with dates and amounts" },
  { label: "Revenue vs. Last Month", value: `revenue comparison for ${new Date().toISOString().split('T')[0].substring(0, 7)} vs ${new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0].substring(0, 7)}` },
  { label: "Inventory Valuation", value: "current total inventory valuation" },
  //{ label: "Expiring Soon (Perishables)", value: "list items expiring within 7 days" },
  { label: "Daily Sales Trend (Last 30 Days)", value: `daily sales trend from ${new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]} to ${new Date().toISOString().split('T')[0]}` },
  { label: "Stock Movement (Last 30 Days)", value: `stock changes for all items from ${new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]} to ${new Date().toISOString().split('T')[0]}` },
  { label: "Profit Margin (Last 30 Days)", value: `profit margin for sales from ${new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]} to ${new Date().toISOString().split('T')[0]}` },
  { label: "Sales by Category (Last 30 Days)", value: `sales breakdown by category from ${new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]} to ${new Date().toISOString().split('T')[0]}` },
  { label: "Average Order Value (Last 3 Months)", value: `average order value from ${new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString().split('T')[0]} to ${new Date().toISOString().split('T')[0]}` },
  //{ label: "Payment Method Distribution (Last 3 Months)", value: `payment method distribution from ${new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString().split('T')[0]} to ${new Date().toISOString().split('T')[0]}` },
  { label: "Order Fulfillment Time (Last 3 Months)", value: `average fulfillment time for orders from ${new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString().split('T')[0]} to ${new Date().toISOString().split('T')[0]}` },
]

// [
//   // 📊 Sales Analytics
//   { label: "Today's Sales", value: `Total sales for ${todayISO}?` },
//   { label: "Best-Selling Product (This Week)", value: `Which product sold the most this week (${thisWeekFrom} to ${thisWeekTo})?` },
//   { label: "Average Daily Sales (This Month)", value: `What is the average daily sales for ${thisMonthFrom} to ${thisMonthTo}?` },
//   { label: "Compare Weekly Sales", value: `Compare this week (${thisWeekFrom}–${thisWeekTo}) vs last week (${lastWeekFrom}–${lastWeekTo}).` },

//   // 📦 Inventory & Stock
//   { label: "Low Stock Items", value: "Which items are running low on stock?" },
//   { label: "Out of Stock", value: "Show products that are out of stock." },
//   { label: "No Sales in 30 Days", value: `Which items haven’t sold since ${thirtyAgoISO}?` },
//   { label: "Fast-Selling Products", value: "What products usually sell out the fastest?" },

//   // 💰 Profitability & Cost
//   { label: "Most Profitable Products", value: "Which products bring in the most profit?" },
//   { label: "Revenue vs Cost (Last Month)", value: `How did revenue compare to costs for ${prevMonthFrom} to ${prevMonthTo}?` },
//   { label: "Highest Profit Margins", value: "Which products have the highest profit margins?" }
// ];

// Optional combined export
export const SUGGESTIONS = [...nonCustomPrompts, ...prompts];
